/**
 * TanStack Query hooks for `campaign-description-rich-text-editor`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignDescriptionRichTextEditorQueryKeys,
	type CreateCampaignDescriptionRichTextEditorBody,
	type ListCampaignDescriptionRichTextEditorResponse,
	type CampaignDescriptionRichTextEditorRow,
} from "./api";

export function useCampaignDescriptionRichTextEditorList(): UseQueryResult<ListCampaignDescriptionRichTextEditorResponse, Error> {
	return useQuery({
		queryKey: campaignDescriptionRichTextEditorQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignDescriptionRichTextEditorCreate(): UseMutationResult<CampaignDescriptionRichTextEditorRow, Error, CreateCampaignDescriptionRichTextEditorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDescriptionRichTextEditorQueryKeys.all });
		},
	});
}

export function useCampaignDescriptionRichTextEditorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignDescriptionRichTextEditorQueryKeys.all });
		},
	});
}
